export const SET_SEARCH_PARAMS = 'set_search_params'
